import React from 'react';
import { api } from '../api.js';
import { PREFERENCES } from './data.jsx';

/**
 * 내 화면 설정(테마·사이드바) — 서버(/api/v1/me/preferences)에 저장해 Teams 탭과 브라우저가 같은 설정을 쓴다(계획 문서 5.1 P1-6).
 * 바꾸면 화면은 바로 바뀌고 저장한다. 저장이 실패하면 화면은 둔 채 알린다(다음 적재 때 서버 값).
 */
export function usePreferences(onError) {
  const [prefs, setPrefs] = React.useState(PREFERENCES);
  const set = React.useCallback((key, value) => {
    setPrefs(p => ({ ...p, [key]: value }));
    api.put('/api/v1/me/preferences', { [key]: value })
      .then(r => setPrefs(r.preferences))
      .catch(e => onError?.('설정을 저장하지 못했습니다 — ' + e.message));
  }, [onError]);
  return [prefs, set, setPrefs];
}
